document.addEventListener('DOMContentLoaded', () => {
    const list = document.getElementById('locations-list');
    const listHidden = document.querySelector('.location_addresses--noscript');
    if (!list) return;

    // Get existing addresses from metaobjects to avoid duplicates
    const getExistingAddresses = () => {
      const existingItems = list.querySelectorAll('.locations__item[data-address]');
      return Array.from(existingItems).map(item => 
        item.getAttribute('data-address').trim().toLowerCase()
      );
    };

    fetch('https://storerocket.io/api/user/ezpBPBxJvy/locations')
      .then((res) => {
        if (!res.ok) throw new Error('Network error');
        return res.json();
      })
      .then((data) => {
        if (!data.results || !Array.isArray(data.results.locations)) return;
        
        const existingAddresses = getExistingAddresses();
        let newLocationsAdded = 0;
        
        // Filter and append only new locations
        data.results.locations.forEach((loc) => {
          if (!loc.visible || !loc.name || !loc.address) return;
          
          // Check if this address already exists
          const normalizedAddress = loc.address.trim().toLowerCase();
          if (existingAddresses.includes(normalizedAddress)) return;
          
          // Create new location item
          const li = document.createElement('li');
          li.className = 'locations__item locations__item--api';
          li.setAttribute('data-address', loc.address);
          li.innerHTML = `
            <span class="locations__name">${loc.name}</span>
            <span class="locations__address">${loc.address}</span>
          `;
          list.appendChild(li);
          newLocationsAdded++;
        });

        console.log(`Added ${newLocationsAdded} new locations from API`);
        
        // Initialize slider after locations are loaded
        initLocationSlider();
      })
      .catch((err) => {
        console.error('Location fetch failed', err);
        if (listHidden) listHidden.classList.remove('hidden');
        
        // Initialize slider even if API fails
        initLocationSlider();
      });
  
  // Initialize slider for existing locations immediately
  initLocationSlider();
  
  // Location slider functionality
  function initLocationSlider() {
    const locationsList = document.getElementById('locations-list');
    const prevBtn = document.getElementById('locations-prev');
    const nextBtn = document.getElementById('locations-next');
    
    if (!locationsList || !prevBtn || !nextBtn) return;
    
    // Calculate scroll distance based on screen size
    function getScrollDistance() {
      const isMobile = window.innerWidth <= 998;
      const columnWidth = locationsList.scrollWidth / ( locationsList.children.length / 6 );
      return columnWidth * (isMobile ? 2 : 4); // 1 column mobile, 4 desktop
    }
    
    // Update button states
    function updateButtons() {
      const isAtStart = locationsList.scrollLeft <= 0;
      const isAtEnd = locationsList.scrollLeft >= locationsList.scrollWidth - locationsList.clientWidth;
      
      prevBtn.disabled = isAtStart;
      nextBtn.disabled = isAtEnd;
    }
    
    // Remove existing listeners to prevent duplicates
    prevBtn.replaceWith(prevBtn.cloneNode(true));
    nextBtn.replaceWith(nextBtn.cloneNode(true));
    
    // Get fresh references after cloning
    const newPrevBtn = document.getElementById('locations-prev');
    const newNextBtn = document.getElementById('locations-next');
    
    // Scroll handlers
    newPrevBtn.addEventListener('click', () => {
      locationsList.scrollBy({
        left: -getScrollDistance(),
        behavior: 'smooth'
      });
    });
    
    newNextBtn.addEventListener('click', () => {
      locationsList.scrollBy({
        left: getScrollDistance(),
        behavior: 'smooth'
      });
    });
    
    // Update buttons on scroll and resize
    locationsList.addEventListener('scroll', updateButtons);
    window.addEventListener('resize', updateButtons);
    
    // Initial button state
    updateButtons();
  }
});